import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'entity_attribute_values',
            name: 'entityAttributeValues',
            class: 'Modules\\EAV\\Entities\\EntityAttributeValues'
        }
    }
}